import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  byId: {},
  actionsloading: false,
});

export function unitsReducer(state = initialState, action) {
  // console.log('in dashboard reduecer....', action)
  switch (action.type) {
    case actionTypes.GET_UNITS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_UNITS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
